import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import { SubheaderShopByCategoryProps } from '../types';
import styles from './style.module.scss';

export const SubheaderShopByCategory: FC<
  PropsWithChildren<SubheaderShopByCategoryProps>
> = (props) => {
  const {
    label,
    isMobile = false,
    isCurrent = false,
    children,
  } = props;
  return (
    <CatPrimaryNavItem
      text={label}
      data-testid="allCategoriesNavItem"
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.SHOP}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      isCurrent={isCurrent}
      className={cx('position-relative', {
        [styles['cat-c-primary-nav__item-panel']]: !isMobile,
        [styles['item-border-top-bottom']]: isMobile,
        [styles['cat-c-primary-nav_mobile']]: isMobile
      })}
      {...(!isMobile
        ?{ variant: 'steppedmegamenu' }
        :{ variant: 'megamenu' })}
    >
      
      {children}

    </CatPrimaryNavItem>
  );
};
